<template>
  <div id="salesforce-auth">
    <button
      id="salesforce-login-button"
      @click="loginHandler"
    >
      Login to Seer
    </button>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { API_ROOT } from '../../config';
import api from '../../_api';
import router from '../../_router';

require('@salesforce/canvas-js-sdk/js/canvas-all.js');

const { Sfdc } = global;

export default {
  name: 'SalesforceAuthInit',
  mounted() {
    localStorage.setItem('sfauthinit_url', window.location.href);

    if (localStorage.getItem('user')) {
      // already logged in
      const user = JSON.parse(localStorage.getItem('user'));
      if (user.token) {
        if (user.profile && user.profile.role === 'manager') {
          router.push('/admin');
        } else {
          router.push('/dashboard');
        }
      }
    }

    global.oauth_callback = (authObject) => {
      const instanceUrl = authObject.instance_url;
      const accessToken = authObject.access_token;

      this.salesforcelogin({ instanceUrl, accessToken });
    };
  },
  methods: {
    ...mapActions('account', ['salesforcelogin']),
    loginHandler(e) {
      const instanceHost = this.getInstanceHost();
      api.get(`${API_ROOT}/salesforce/client_id/instance_url/${instanceHost}`).then((response) => {
        const clientId = response.data.client_id;
        if (!Sfdc.canvas.oauth.loggedin()) {
          const redirectUri = new URL('/salesforce/auth_callback', document.baseURI).href;
          Sfdc.canvas.oauth.login({
            uri: Sfdc.canvas.oauth.loginUrl(),
            params: {
              response_type: 'token',
              client_id: clientId,
              redirect_uri: encodeURIComponent(redirectUri),
            },
          });
        }
      });
      return false;
    },
    getInstanceHost() {
      return Sfdc.canvas.oauth.loginUrl().split('/')[2];
    },
  },
};
</script>

<style>
#salesforce-login-button {
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  height: 38px;
  width: 140px;
  left: 50%;
  right: 50%;
  margin-top: 0;
  margin-left: -70px;
  font-size: 16px;
  font-family: SilkaLight,Helvetica Neue,Arial,sans-serif;
  position: absolute;
  border-width: .75px;
  border-radius: 3px;
  letter-spacing: .25px;
}
</style>
